/**
 * Confirmation for a sensitive administrative action. A native modal <dialog>:
 * focus moves into it, Escape cancels, the page behind is inert, and the
 * consequence is stated before anything is sent.
 */
import { useEffect, useRef } from 'react';

export interface PendingConfirmation {
  readonly title: string;
  readonly body: string;
  readonly confirmLabel: string;
  readonly danger?: boolean;
  readonly onConfirm: () => void;
}

export function ConfirmDialog({
  pending,
  onClose,
}: {
  pending: PendingConfirmation | null;
  onClose: () => void;
}) {
  const ref = useRef<HTMLDialogElement>(null);
  useEffect(() => {
    const d = ref.current;
    if (!d) return;
    if (pending && !d.open) d.showModal();
    if (!pending && d.open) d.close();
  }, [pending]);

  return (
    <dialog ref={ref} onClose={onClose} aria-labelledby="confirm-title">
      {pending ? (
        <form
          method="dialog"
          onSubmit={(event) => {
            event.preventDefault();
            pending.onConfirm();
            onClose();
          }}
        >
          <h2 id="confirm-title">{pending.title}</h2>
          <p>{pending.body}</p>
          <div className="actions" style={{ justifyContent: 'flex-end', marginTop: 20 }}>
            <button type="button" onClick={onClose} autoFocus>
              Cancel
            </button>
            <button type="submit" className={pending.danger ? 'danger primary' : 'primary'}>
              {pending.confirmLabel}
            </button>
          </div>
        </form>
      ) : null}
    </dialog>
  );
}
